import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seller_filter = _resolveComponent("seller-filter");
  const _component_marketplace_filter = _resolveComponent("marketplace-filter");
  const _component_empty_segments = _resolveComponent("empty-segments");
  const _component_segment_filter = _resolveComponent("segment-filter");
  const _component_product_filter = _resolveComponent("product-filter");
  const _component_brand_filter = _resolveComponent("brand-filter");
  const _component_multi_mode_date_picker = _resolveComponent("multi-mode-date-picker");
  const _component_multi_mode_date_picker_u_i_text = _resolveComponent("multi-mode-date-picker-u-i-text");
  const _component_date_picker_filter = _resolveComponent("date-picker-filter");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_seller_filter, {
    sellers: _ctx.sellers_filter,
    onApply: $options.applySellers
  }, null, 8, ["sellers", "onApply"]), _createVNode(_component_marketplace_filter, {
    marketplaces: _ctx.marketplaces_filter,
    onApply: $options.applyMarketplaces
  }, null, 8, ["marketplaces", "onApply"]), _createVNode(_component_segment_filter, {
    segments: _ctx.segments_filter,
    sellers: _ctx.sellers_filter,
    onApply: $options.applySegments
  }, {
    empty: _withCtx(() => [_createVNode(_component_empty_segments)]),
    _: 1
  }, 8, ["segments", "sellers", "onApply"]), _createVNode(_component_product_filter, {
    products: _ctx.products,
    sellers: _ctx.sellers_filter,
    marketplaces: _ctx.marketplaces_filter,
    onApply: $options.applyProducts,
    onCleared: $options.handleProductsCleared
  }, null, 8, ["products", "sellers", "marketplaces", "onApply", "onCleared"]), $options.showBrandsFilter ? (_openBlock(), _createBlock(_component_brand_filter, {
    key: 0,
    brands: _ctx.brands_filter,
    onApply: $options.applyBrands
  }, null, 8, ["brands", "onApply"])) : _createCommentVNode("", true), _createVNode(_component_date_picker_filter, {
    "no-caret": "",
    date: $options.datePickerDate,
    ref: "datePickerFilter",
    loading: $props.loading,
    onHidden: $options.handleDatePickerCancel
  }, {
    body: _withCtx(() => [_createVNode(_component_multi_mode_date_picker, {
      ref: "datePicker",
      onSubmit: $options.handleDatePickerSubmit,
      onCancel: $options.handleDatePickerCancel
    }, null, 8, ["onSubmit", "onCancel"])]),
    "date-picker-body": _withCtx(() => [_createVNode(_component_multi_mode_date_picker_u_i_text, {
      start: $options.datePickerDisplayDate('start'),
      end: $options.datePickerDisplayDate('end')
    }, null, 8, ["start", "end"])]),
    _: 1
  }, 8, ["date", "loading", "onHidden"])], 64);
}